export default {"src":"/_next/static/media/0xb9d7dddca9a4ac480991865efef82e01273f79c3.68849d17.svg","height":264,"width":262,"blurWidth":0,"blurHeight":0};